﻿export class UnitOfMeasurement {
    public name: string;
    public multiplier: number;
    public offset: number;
        
    public static create(name: string, multiplier: number, offset?: number) {
        let result = new UnitOfMeasurement();
        result.name = name;
        result.multiplier = multiplier;
        result.offset = offset ? offset : 0;
        return result;
    }
}

export class Units {
    public static distance: UnitOfMeasurement[] = [
        UnitOfMeasurement.create("meters", 1),
        UnitOfMeasurement.create("millimeters", 1000),
        UnitOfMeasurement.create("centimeters", 100),
        UnitOfMeasurement.create("kilometers", 0.001),
        UnitOfMeasurement.create("inches", 39.3701),
        UnitOfMeasurement.create("feet", 3.28084),
        UnitOfMeasurement.create("yards", 1.09361),
        UnitOfMeasurement.create("miles", 0.000621371)
    ];

    public static area: UnitOfMeasurement[] = [
        UnitOfMeasurement.create("sq. millimeters", 1000000),
        UnitOfMeasurement.create("sq. centimeters", 10000),
        UnitOfMeasurement.create("sq. meters", 1),
        UnitOfMeasurement.create("sq. kilometers", 0.000001),
        UnitOfMeasurement.create("sq. yard", 1.19599),
        UnitOfMeasurement.create("sq. feet", 10.7639),
        UnitOfMeasurement.create("sq. inch", 1550),
        UnitOfMeasurement.create("hectacre", 0.0001),
        UnitOfMeasurement.create("acre", 0.000247105)
    ];

    public static volume: UnitOfMeasurement[] = [
        UnitOfMeasurement.create("liters", 1),
        UnitOfMeasurement.create("US gallons", 0.264172),
        UnitOfMeasurement.create("US quarts", 1.05669),
        UnitOfMeasurement.create("US pints", 2.11338),
        UnitOfMeasurement.create("US cups", 4.16667),
        UnitOfMeasurement.create("US ounces", 33.814),
        UnitOfMeasurement.create("US tablespoons", 67.628),
        UnitOfMeasurement.create("US teaspoons", 202.884),
        UnitOfMeasurement.create("cubic meters", 0.001),
        UnitOfMeasurement.create("milliliters", 1000),
        UnitOfMeasurement.create("imperial gallons", 0.219969),
        UnitOfMeasurement.create("imperial quarts", 0.879877),
        UnitOfMeasurement.create("imperial pints", 1.75975),
        UnitOfMeasurement.create("imperial cups", 3.51951),
        UnitOfMeasurement.create("imperial ounces", 35.1951),
        UnitOfMeasurement.create("imperial tablespoons", 56.3121),
        UnitOfMeasurement.create("imperial teaspoons", 168.936),
        UnitOfMeasurement.create("cubic feet", 0.0353147),
        UnitOfMeasurement.create("cubic inches", 61.0237)
    ];

    /*public static temperature: UnitOfMeasurement[] = [
        UnitOfMeasurement.create("kelvin", 1),
        UnitOfMeasurement.create("celsius", 1, 272.15),
        UnitOfMeasurement.create("fahrenheit", 1.8, 255.372)
    ];*/

    public static weight: UnitOfMeasurement[] = [
        UnitOfMeasurement.create("kilograms", 1),
        UnitOfMeasurement.create("grams", 1000),
        UnitOfMeasurement.create("metric tons", 0.001),
        UnitOfMeasurement.create("milligrams", 1000000),
        UnitOfMeasurement.create("micrograms", 1000000000),
        UnitOfMeasurement.create("imperial tons", 0.000984207),
        UnitOfMeasurement.create("US tons", 0.00110231),
        UnitOfMeasurement.create("stones", 0.157473),
        UnitOfMeasurement.create("pounds", 2.20462),
        UnitOfMeasurement.create("ounces", 35.274)
    ];

    public static pressure: UnitOfMeasurement[] = [
        UnitOfMeasurement.create("pascals", 1),
        UnitOfMeasurement.create("bars", 0.00001),
        UnitOfMeasurement.create("atmospheres", 0.0000098692),
        UnitOfMeasurement.create("psi", 0.000145038),
        UnitOfMeasurement.create("torrs", 0.00750062),
        UnitOfMeasurement.create("hg", 0.0002953)
    ];

    public static angle: UnitOfMeasurement[] = [
        UnitOfMeasurement.create("radians", 1),
        UnitOfMeasurement.create("degrees", 57.2958),
        UnitOfMeasurement.create("gradians", 63.662),
        UnitOfMeasurement.create("milliradians", 1000),
        UnitOfMeasurement.create("minutes", 3437.75),
        UnitOfMeasurement.create("seconds", 206265)
    ];

    public static convert(type: string, from: string, to: string, value: number): number {
        let measurements: UnitOfMeasurement[] = Units[type];
        if (!measurements) throw new Error("Unit type " + type + " not found");
        let fromUnit = measurements.find(m => m.name == from);
        if (!fromUnit) throw new Error("Unit " + from + "not found");
        let toUnit = measurements.find(m => m.name == to);
        if (!toUnit) throw new Error("Unit " + to + " not found");
        return Math.round(((value * 1 / fromUnit.multiplier * toUnit.multiplier) -
            ((toUnit.offset * toUnit.multiplier) - (fromUnit.offset * fromUnit.multiplier))) * 10000) / 10000;
    }
}
